// Pin the self-update source to the whopio release repo *path*, not just the host:
// GitHub's release/content hosts are multi-tenant, so a host allowlist would still
// accept an attacker's own file on them. Loopback is allowed for dev/tests. The
// real fix is manifest signing; this only constrains where updates come from.

const RELEASE_PATH_PREFIX = "/whopio/whop-public-cli/releases/";

function isLoopbackHost(host: string): boolean {
	return (
		host === "localhost" ||
		host === "127.0.0.1" ||
		host === "::1" ||
		host === "[::1]"
	);
}

export function isTrustedUpdateUrl(raw: string): boolean {
	let url: URL;
	try {
		url = new URL(raw);
	} catch {
		return false;
	}
	if (isLoopbackHost(url.hostname)) return true;
	return (
		url.protocol === "https:" &&
		url.hostname === "github.com" &&
		url.pathname.startsWith(RELEASE_PATH_PREFIX)
	);
}
